export enum MemberPreferenceType {
    Email = 20,
    Phone = 21,
    NotifyMe = 22,
    MyRetailSiteEmail = 23,
    MyretailSitePhone = 24,
    PrivacyPreference = 19,
    AmazonSubscription = 25,
    PreferredCommunicationLanguage = 6
}



// WEBPACK FOOTER //
// ./src/app/common/enums/member-preference.enum.ts